'use client';

export { default } from './DialogTitle';
export { default as dialogTitleClasses } from './dialogTitleClasses';
export * from './dialogTitleClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/DialogTitle/index.js
// module id = 921
// module chunks = 25